import {TableColumnsType} from 'antd';

import {Locale} from '../../../../provider/locale/locale';

import {EventsTableRenderingType} from './events-table-type';

export const eventsTableColumnList: TableColumnsType<EventsTableRenderingType> = [
    {
        title: <Locale stringKey="POSTS__TABLE__TITLE" />,
        dataIndex: 'title',
    },
    {
        title: <Locale stringKey="POSTS__TABLE__PREVIEW" />,
        dataIndex: 'preview',
        width: 80,
    },
    {
        title: <Locale stringKey="POSTS__TABLE__STATUS" />,
        dataIndex: 'status',
    },
    {
        title: <Locale stringKey="POSTS__TABLE__START_AT" />,
        dataIndex: 'startAt',
    },
    {
        title: <Locale stringKey="POSTS__TABLE__FINISH_AT" />,
        dataIndex: 'finishAt',
    },
    {
        title: <Locale stringKey="POSTS__TABLE__COMPANIES_COUNT" />,
        dataIndex: 'companiesCount',
    },
    {
        title: <Locale stringKey="POSTS__TABLE__DATE" />,
        dataIndex: 'date',
    },
    {
        title: <Locale stringKey="POSTS__TABLE__ACTIONS" />,
        dataIndex: 'actions',
        width: 100,
    },
];
